/**
 * Export component file to be used on project
 */

import FloatActionButtonMobile from './FloatActionButtonMobile';
export default FloatActionButtonMobile;